import useSWR from 'swr';
import api from '../../config/configApi';

const getToken = () => localStorage.getItem('token');

const fetcher = async (url) => {
  const token = getToken();
  const { data } = await api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (data?.erro) throw new Error(data?.mensagem || 'Erro na API');
  return data?.advogados ?? [];
};

export default function useAdvogadosConfiguracoes() {
  const {
    data: advogados = [],
    error,
    isLoading,
    mutate,
  } = useSWR('/advogados/config', fetcher);

  const criarAdvogado = async (payload) => {
    const token = getToken();
    const { data } = await api.post('/advogados/config', payload, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (data?.erro) throw new Error(data?.mensagem || 'Não foi possível criar.');
    await mutate();
  };

  const editarAdvogado = async (id, payload) => {
    const token = getToken();
    const { data } = await api.put(`/advogados/config/${id}`, payload, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (data?.erro) throw new Error(data?.mensagem || 'Não foi possível editar.');
    await mutate();
  };

  return {
    advogados,
    isLoading,
    isError: !!error,
    error,
    criarAdvogado,
    editarAdvogado,
    refetch: mutate,
  };
}
